import { useEffect } from 'react';
import { copyToClipboard, getDateFormatted } from 'Core/data/Helpers';
import { NavLink } from "react-router-dom";
import { useIntl } from "react-intl";
import { useSelector, useDispatch } from 'react-redux';
import { Tooltip } from "@gpstrackit/react-controls";

//Controls
import { Grid, Icon } from '@mui/material';

//Components
import ChipStatus from 'Components/ChipStatus';

//Actions
import { deviceDetailGetDataRequest, clearRedux, showPulsInfoModal, searchEntityRequest } from 'Redux/actions';

const DeviceInfo = (props) => {
    const { device, deviceId } = props
    const { messages } = useIntl();
    const dispatch = useDispatch();

    const ctcAccounts = useSelector(state => state.generalRedux.ctcAccounts);

    useEffect(() => {
        dispatch(deviceDetailGetDataRequest(deviceId))
        /* if (!ctcAccounts || ctcAccounts?.length === 0) */ dispatch(searchEntityRequest({ key: "ctcAccounts" }));
        return () => {
            dispatch(clearRedux("DEVICE_DETAIL", { device: null }))
        }
    }, [])

    let currentAccount = ctcAccounts?.length ? ctcAccounts?.find((item) => item?.id === device?.unitConfig?.accountId) : null

    return (
        <Grid container style={{ marginTop: 10 }}>
            <Grid item xs={5} style={{ textAlign: 'left', marginTop: 5 }}>
                <p className="text-muted mb-2">
                    {messages['device_overview_manufacturer']}
                </p>
                <p className="mb-2">{device?.deviceModel?.manufacturer?.name || ""}</p>
            </Grid>
            <Grid item xs={5} style={{ textAlign: 'left', marginTop: 5 }}>
                <p className="text-muted mb-2">
                    {messages['device_overview_serial']}
                </p>
                <p className="mb-2">
                    {
                        device?.esn &&
                        <Grid style={{ display: 'flex', alignItems: 'center' }}>
                            {device.esn}
                            <span style={{ marginLeft: 5, marginTop: 2 }} className="cursor-pointer ml-1"
                                onClick={() => copyToClipboard(device?.esn, messages['common_copied'])}
                            >
                                <Icon style={{ fontSize: 18 }} >content_copy</Icon>
                            </span>
                        </Grid>
                    }
                </p>
            </Grid>
            <Grid item xs={5} style={{ textAlign: 'left', marginTop: 5 }}>
                <p className="text-muted mb-2">
                    {messages['device_overview_imei']}
                </p>
                <p className="mb-2">
                    {
                        device?.imei &&
                        <Grid style={{ display: 'flex', alignItems: 'center' }}>
                            {device?.imei}
                            <span style={{ marginLeft: 5, marginTop: 2 }} className="cursor-pointer ml-1"
                                onClick={() => copyToClipboard(device?.imei, messages['common_copied'])}
                            >
                                <Icon style={{ fontSize: 18 }}>content_copy</Icon>
                            </span>
                        </Grid>
                    }
                </p>
            </Grid>
            <Grid item xs={5} style={{ textAlign: 'left', marginTop: 5 }}>
                <p className="text-muted mb-2">
                    {messages['device_overview_status']}
                </p>
                <p className="mb-2">
                    <span>{device?.status && <ChipStatus statusCode={device?.status} messages={messages} />}</span>
                </p>
            </Grid>
            <Grid item xs={5} style={{ textAlign: 'left', marginTop: 5 }}>
                <p className="text-muted mb-2">
                    {messages['device_overview_sim_phone']}
                </p>
                <p className="mb-2">{device?.simCard?.msisdn || ""}</p>
            </Grid>
            {
                device &&
                device.deviceModel.manufacturer &&
                device.deviceModel.manufacturer.name.toUpperCase() === "Calamp".toUpperCase() &&
                <Grid item xs={5} style={{ textAlign: 'left', marginTop: 5 }}>
                    <p className="text-muted mb-2">
                        {messages['device_overview_puls_customer']}
                    </p>
                    <p className="mb-2">{<span>{currentAccount?.name ? currentAccount?.name : device?.unitConfig?.pulsCustomerId || ""}</span>}</p>
                </Grid>
            }
            {
                device &&
                device.deviceModel.manufacturer &&
                device.deviceModel.manufacturer.name.toUpperCase() === "Calamp".toUpperCase() &&
                <Grid item xs={5} style={{ textAlign: 'left', marginTop: 5 }}>
                    <p className="text-muted mb-2">
                        {messages['device_overview_puls_info']}
                    </p>
                    <p className="mb-2">
                        {
                            device?.unitConfig?.pulsCustomerId ?
                                <a
                                    className="btn-link text-underlined"
                                    onClick={() => {
                                        dispatch(showPulsInfoModal())
                                    }}
                                >
                                    <u>{messages['common_show']}</u>
                                </a>
                                :
                                "---------"
                        }
                    </p>
                </Grid>
            }
            {
                device &&
                device.deviceModel.manufacturer &&
                device.deviceModel.manufacturer.name.toUpperCase() === "Calamp".toUpperCase() &&
                device.unitConfig.calampApi !== "CTC" &&
                <Grid item xs={5} style={{ textAlign: 'left', marginTop: 5 }}>
                    <p className="text-muted mb-2">
                        {messages['device_overview_puls_group']}
                    </p>
                    <p className="mb-2">{<span>{device?.unitConfig?.pulsGroup || ""}</span>}</p>
                </Grid>
            }
            {
                device?.deviceModel?.manufacturer &&
                (device?.deviceModel?.manufacturer?.name.toUpperCase() === "Calamp".toUpperCase()) &&
                <Grid item xs={5} style={{ textAlign: 'left', marginTop: 5 }}>
                    <p className="text-muted mb-2">
                        {messages['device_overview_script']}
                    </p>
                    <p className="mb-2">
                        {
                            device?.unitConfig?.scriptVersion &&
                            <span>
                                {device?.unitConfig?.scriptVersion || ""}.{device?.unitConfig?.configVersion || ""}
                            </span>
                        }{
                            device?.unitConfig?.calampApi === "CTC" && device?.unitConfig?.configVersion &&
                            <span>
                                {device?.unitConfig?.configVersion}
                            </span>
                        }
                    </p>
                </Grid>
            }
            {
                device?.deviceModel?.manufacturer &&
                (device?.deviceModel?.manufacturer?.name.toUpperCase() === "Geometris".toUpperCase()) &&
                <Grid item xs={5} style={{ textAlign: 'left', marginTop: 5 }}>
                    <p className="text-muted mb-2">
                        {messages['device_overview_assigned_script']}
                    </p>
                    <p className="mb-2">
                        {
                            device?.unitConfig?.configVersion &&
                            <span>
                                {device?.unitConfig?.configVersion || ""}
                            </span>
                        }
                    </p>
                </Grid>
            }
            <Grid item xs={5} style={{ textAlign: 'left', marginTop: 5 }}>
                <p className="text-muted mb-2">
                    {messages['device_overview_sim_provider_account']}
                </p>
                <p className="mb-2">
                    {
                        device?.simCard?.simProviderAccount &&
                        <Grid>
                            {device?.simCard?.simProviderAccount?.name} - {device?.simCard?.simProviderAccount?.simProvider?.name}
                            {
                                (device?.simCard?.simProviderAccount?.simProvider?.name?.toUpperCase() === "AT&T".toUpperCase() || device?.simCard?.simProviderAccount?.simProvider?.name?.toUpperCase() === "InTouch ATT".toUpperCase()) &&
                                <Grid>
                                    {" - "}
                                    <a
                                        className="btn-link"
                                        onClick={() => {
                                            //if (device && device.ICCID && device.SIMProvider)
                                            //    this.props.simDeviceInfoModalShow(device.ICCID, device.SIMProvider)
                                        }}
                                    >
                                        {messages['common_show']}
                                    </a>
                                </Grid>
                            }
                        </Grid>

                    }
                </p>
            </Grid>
            <Grid item xs={5} style={{ textAlign: 'left', marginTop: 5 }}>
                <p className="text-muted mb-2">
                    {messages['device_overview_created_at']}
                </p>
                <p className="mb-2">
                    {device?.createdOn && getDateFormatted(device?.createdOn, "date", "datetime")}
                </p>
            </Grid>
            <Grid item xs={5} style={{ textAlign: 'left', marginTop: 5 }}>
                <p className="text-muted mb-2">
                    {messages['device_overview_created_by']}
                </p>
                <p className="mb-2">
                    {device?.createdBy || ''}
                </p>
            </Grid>
            <Grid item xs={5} style={{ textAlign: 'left', marginTop: 5 }}>
                <p className="mb-2">
                    <span className="text-muted">
                        {messages['device_overview_unit_time']}
                    </span>
                </p>
                <p className="mb-2">
                    {
                        <span>
                            {device?.lastReading?.unitTime && getDateFormatted(device?.lastReading?.unitTime, "date", "datetime", device.timezone)}
                        </span>
                    }
                </p>
            </Grid>
            <Grid item xs={5} style={{ textAlign: 'left', marginTop: 5 }}>
                <p className="text-muted mb-2">
                    {messages['device_overview_server_time']}
                </p>
                <p className="mb-2">
                    {
                        <span>
                            {device?.lastReading?.serverTime && getDateFormatted(device?.lastReading?.serverTime, "date", "datetime", device.timezone)}
                        </span>
                    }
                </p>
            </Grid>
            <Grid item xs={5} style={{ textAlign: 'left', marginTop: 5 }}>
                <p className="text-muted mb-2">
                    {messages['device_overview_last_message_time']}
                </p>
                <p className="mb-2">
                    {
                        <span>
                            {device?.lastReading?.lastMessageTime && getDateFormatted(device?.lastReading?.lastMessageTime, "date", "datetime", device.timezone)}
                        </span>
                    }
                </p>
            </Grid>
            <Grid item xs={5} style={{ textAlign: 'left', marginTop: 5 }}>
                <p className="text-muted  mb-2">
                    {messages['device_overview_age']}
                </p>
                <p className="mb-2">
                    {
                        <span>
                            {device?.lastReading?.lastMessageTime && getDateFormatted(device?.lastReading?.lastMessageTime, "date", "age", device.timezone)}
                        </span>
                    }
                </p>
            </Grid>
            {
                device?.refurbishedUnit?.refurbishedUnitId &&
                <Grid item xs={5} style={{ textAlign: 'left', marginTop: 5 }}>
                    <div>
                        <p className="text-muted mb-2">
                            {messages['device_overview_refurbish_from']}
                        </p>
                        <p className="mb-2">
                            <Tooltip title={messages["device_overview_refurbish_message"]} tooltipPlacement={"left"}>
                                <NavLink
                                    style={{
                                        backgroundColor: "white",
                                        textDecoration: "underline",
                                        color: "black"
                                    }}
                                    to={`/app/devices/overview/${device?.refurbishedUnit?.refurbishedUnitId}`}

                                >
                                    {`${device?.refurbishedUnit?.esn}`}
                                </NavLink>
                            </Tooltip>
                        </p>
                    </div>
                </Grid>
            }
        </Grid>
    )
}

export default DeviceInfo;